// Menu.jsx
import { Tabs, Tab } from "@heroui/react";
import AcquisitionBuildings from "./screens/buildings.tsx";
import AcquisitionTransactionDetails from "./screens/transaction.tsx";

const Menu = ({ updateAcquisitionFile, acquisitionFile }: any) => {
  return (
    <Tabs
      variant="underlined"
      aria-label="Options"
      classNames={{
        base: "shadow-[inset_0_-1px_0_0_rgba(49,64,59,0.2)]",
        tabList: "p-0 gap-6",
        tab: "text-base px-0 py-0 h-fit",
        tabContent:
          "py-2 w-full text-neutral-secondary-mid hover:text-neutral-primary",
      }}
    >
      <Tab key="buildings" title="Gebouwen">
        <AcquisitionBuildings
          updateAcquisitionFile={updateAcquisitionFile}
          buildings={acquisitionFile.buildings}
          acquisitionFile={acquisitionFile}
        />
      </Tab>
      <Tab key="transaction" title="Transactie">
        <AcquisitionTransactionDetails
          updateAcquisitionFile={updateAcquisitionFile}
          transactionDetails={acquisitionFile}
        />
      </Tab>
    </Tabs>
  );
};

export default Menu;
